import { Box } from '@enaep-ng/benchmark';
import * as styleSheet from '../styles';
import React from 'react';
import '../utils.css';
import { ProgressType } from '../types';

const Progress: React.FC<ProgressType> = ({ variant, level }) => {
  const progress = level > 100 ? 100 : level < 0 ? 0 : level;

  return (
      <Box sx={styleSheet.customProgressBar}>
        <Box
          className={`${variant} customized-progress-bar-animated`}
          style={{ width: `${progress}%` }}
          sx={styleSheet.customProgressBarFill}
        >
          <Box sx={styleSheet.customizedProgressBarLabel}>{`${progress}%`}</Box>
        </Box>
      </Box>
  );
};

export default Progress;
